import React from 'react'
import { Button } from 'components'
import { ExclamationCircleFilled } from '@ant-design/icons'
import styles from './index.module.less'
import { unmountComponentAtNode, render } from 'react-dom'
import lodash from 'lodash'

interface LoginTips {
  onCancel?: Function
  onOk?: Function
  content?: string | React.ReactDOM
}

const Message = ({ onCancel, onOk, content }: LoginTips) => {
  return (
    <div className={styles.modal}>
      <div className={styles.tips}>
        <div className={styles.iconbox}>
          <span>
            <ExclamationCircleFilled className={styles.icon} />
          </span>
          <p>安全提示</p>
        </div>
        <div className={styles.text}>
          <p className={styles.textCont}>{content}</p>
        </div>
        <div className={styles.but}>
          <Button onClick={onCancel}>稍后验证</Button>
          <Button
            type="primary"
            onClick={() => {
              onCancel && onCancel()
              onOk && onOk()
            }}>
            立即验证
          </Button>
        </div>
      </div>
    </div>
  )
}

const getContainer = () => {
  const container = document.querySelector('#customMessageWrapper')
  if (!container) {
    const _container = document.createElement('div')
    _container.id = 'customMessageWrapper'
    document.body.appendChild(_container)
    return _container
  }
  return container
}

export default function Index(props: LoginTips) {
  const container = getContainer()
  const _dom = document.createElement('div')

  container.appendChild(_dom)

  const hanldeClose = () => {
    unmountComponentAtNode(_dom)
    container.removeChild(_dom)
  }

  render(<Message onCancel={lodash.debounce(hanldeClose)} {...props} />, _dom)
}
